import type { Dictionary } from './en';

/**
 * Arabic (العربية). Right-to-left.
 *
 * ⚠️ Not natively reviewed. The certificate wording especially should be checked
 * by a speaker — a mistranslation here could mislead someone about whether food
 * is halal.
 */
export const ar: Dictionary = {
    'nav.find': 'ابحث',
    'nav.prayer': 'الصلاة',
    'nav.cards': 'البطاقات',
    'nav.saved': 'المحفوظات',
    'nav.main': 'التنقل الرئيسي',
    'nav.skip': 'تخطَّ إلى المحتوى',

    'search.placeholder': 'ابحث في {city}',
    'search.label': 'ابحث عن أماكن في {city}',
    'search.clear': 'مسح البحث',
    'search.matches': '{count} نتيجة',
    'search.matches_one': 'نتيجة واحدة',
    'city.choose': 'اختر مدينة',
    'city.trust.certified': 'معتمدة',
    'city.trust.mixed': 'معتمدة جزئياً',
    'city.trust.community': 'من المجتمع',

    'filter.label': 'تصفية النتائج',
    'filter.eat': 'للأكل',
    'filter.shop': 'للتسوق',
    'filter.pray': 'للصلاة',
    'filter.certifiedOnly': 'المعتمدة فقط',
    'filter.hideExpired': 'إخفاء المنتهية',
    'filter.nearMe': 'ضمن ٢ كم',
    'filter.clear': 'مسح',
    'filter.noneCertified': 'لا توجد أماكن معتمدة في هذه المدينة',
    'filter.noneExpired': 'لا توجد شهادات منتهية هنا',

    'results.count': '{count} مكاناً',
    'results.count_one': 'مكان واحد',
    'results.nearestFirst': '، الأقرب أولاً',
    'results.loading': 'جارٍ تحميل {city}…',
    'results.error': 'تعذّر تحميل {city}. تحقق من اتصالك وحاول مرة أخرى.',
    'results.emptyTitle': 'لا توجد نتائج تطابق هذه التصفية.',
    'results.emptyBody': 'جرّب إزالة أحد المرشحات، أو ابحث باسم أو منطقة أخرى.',
    'results.clearAll': 'مسح كل المرشحات',
    'results.heading': 'أماكن حلال في {city}',

    'banner.community': 'غير معتمدة.',
    'banner.communityBody':
        'هذه الأماكن البالغ عددها {count} مصدرها {source}. لم تتحقق منها أي جهة اعتماد حلال — اسأل العاملين قبل الطلب.',
    'banner.certified': '{certified} من {total} تحمل شهادة سارية',
    'banner.certifiedBody': ' من {source}.',
    'banner.lapsed': ' انتهت صلاحية {count} منها وهي مُعلَّمة بذلك.',
    'banner.lapsed_other': ' انتهت صلاحية {count} منها وهي مُعلَّمة بذلك.',
    'banner.mixedTail': ' الباقي إدراجات من المجتمع وغير معتمدة.',
    'banner.checked': 'جرى التحقق مع {source} {when}.',

    'assurance.certified': 'حلال معتمد',
    'assurance.certified.short': 'معتمد',
    'assurance.certified.detail': 'يحمل المكان شهادة حلال من جهة اعتماد معترف بها.',
    'assurance.certified_kitchen': 'مطبخ حلال معتمد',
    'assurance.certified_kitchen.short': 'مطبخ معتمد',
    'assurance.certified_kitchen.detail': 'مطبخ حلال معتمد ومخصص داخل مكان يقدّم أيضاً طعاماً غير حلال.',
    'assurance.muslim_friendly': 'مناسب للمسلمين',
    'assurance.muslim_friendly.short': 'مناسب',
    'assurance.muslim_friendly.detail': 'معتمد بأنه لا يقدّم لحم خنزير ولا كحول، لكنه ليس مكاناً حلالاً بالكامل.',
    'assurance.muslim_owned': 'ملكية مسلمة',
    'assurance.muslim_owned.short': 'ملكية مسلمة',
    'assurance.muslim_owned.detail': 'يملكه مسلمون، دون شهادة من جهة خارجية.',
    'assurance.self_declared': 'حلال بإقرار المكان',
    'assurance.self_declared.short': 'بإقرار المكان',
    'assurance.self_declared.detail': 'يقول المكان إنه يقدّم طعاماً حلالاً. لم تتحقق من ذلك أي جهة اعتماد.',
    'assurance.community_reported': 'مُبلَّغ من المجتمع',
    'assurance.community_reported.short': 'من المجتمع',
    'assurance.community_reported.detail':
        'أضافه متطوعو OpenStreetMap. لم تعتمده أي جهة — اسأل العاملين قبل الطلب.',

    'cert.label': 'شهادة حلال',
    'cert.current': 'الشهادة سارية',
    'cert.expiring_soon': 'تنتهي قريباً',
    'cert.expired': 'انتهت صلاحية الشهادة',
    'cert.renewal_pending': 'التجديد قيد الإجراء',
    'cert.listed': 'مُدرج كمعتمد',
    'cert.delisted': 'أُزيل من السجل',
    'cert.unknown': 'الحالة غير معروفة',
    'cert.reference': 'رقم الشهادة',
    'cert.category': 'الفئة',
    'cert.validUntil': 'سارية حتى',
    'cert.expiredOn': 'انتهت في',
    'cert.confirmed': 'تم التأكد',
    'cert.noEndDate': 'لا يُنشر تاريخ انتهاء',
    'cert.noCertifier': 'جهة الاعتماد غير مسجّلة',
    'cert.expiredNote': 'انتهت صلاحية هذه الشهادة. ربما جُدّدت منذ ذلك الحين — اسأل المكان قبل الطلب.',
    'cert.delistedNote': 'لم يعد هذا المكان في سجل {certifier}. تعامل معه على أنه غير معتمد.',
    'cert.pendingNote': 'يُدرج السجل هذه الشهادة على أنها قيد التجديد.',
    'cert.openEndedNote':
        'لا تنشر جهة الاعتماد هذه تواريخ انتهاء. يبقى المكان في السجل حتى تُسحب شهادته.',
    'cert.ariaValid': 'سارية حتى {date}',
    'cert.ariaExpired': 'انتهت في {date}',
    'cert.ariaOpen': 'لا يُنشر تاريخ انتهاء. تم التأكد {when}.',

    'place.back': 'العودة إلى القائمة',
    'place.save': 'حفظ',
    'place.saved': 'محفوظ',
    'place.address': 'العنوان',
    'place.hours': 'ساعات العمل',
    'place.phone': 'الهاتف',
    'place.directions': 'الاتجاهات',
    'place.website': 'الموقع الإلكتروني',
    'place.share': 'مشاركة',
    'place.listedBy': 'مُدرج من {source}',
    'place.checkedWhen': 'جرى التحقق من الشهادة {when}',
    'place.approximate': 'موقع تقريبي — حُدِّد في {district} لأن العنوان لم يُطابَق بمبنى بعينه.',
    'place.theDistrict': 'المنطقة',
    'place.away': 'على بُعد {distance}',

    'type.restaurant': 'مطعم',
    'type.cafe': 'مقهى',
    'type.bakery': 'مخبز',
    'type.fast_food': 'وجبات سريعة',
    'type.food_court': 'ساحة طعام',
    'type.hotel_restaurant': 'مطعم فندق',
    'type.grocery': 'بقالة',
    'type.butcher': 'ملحمة',
    'type.mosque': 'مسجد',
    'type.prayer_room': 'مصلّى',
    'type.attraction_dining': 'مطعم في موقع سياحي',

    'prayer.title': 'الصلاة',
    'prayer.needLocation': 'اسمح بالوصول إلى موقعك للحصول على مواقيت الصلاة واتجاه القبلة من مكانك.',
    'prayer.next': 'التالية',
    'prayer.fajr': 'الفجر',
    'prayer.sunrise': 'الشروق',
    'prayer.dhuhr': 'الظهر',
    'prayer.asr': 'العصر',
    'prayer.maghrib': 'المغرب',
    'prayer.isha': 'العشاء',
    'prayer.inHours': 'بعد {hours} س {minutes} د',
    'prayer.inMinutes': 'بعد {minutes} د',
    'prayer.imminent': 'بعد أقل من دقيقة',
    'prayer.highLatitude':
        'عند خط العرض هذا لا تنخفض الشمس تحت الأفق بما يكفي لحساب الفجر والعشاء بالطريقة المعتادة اليوم. اتبع جدول مسجدك المحلي.',
    'prayer.method': 'طريقة الحساب',
    'prayer.methodLabel': 'الطريقة',
    'prayer.asrLabel': 'العصر',
    'prayer.asrStandard': 'الجمهور (الشافعي والمالكي والحنبلي)',
    'prayer.asrHanafi': 'الحنفي',
    'prayer.calcNote':
        'تُحسب على جهازك من موقعك، فتعمل دون اتصال. المواقيت للاسترشاد — اتبع مسجدك المحلي عند الاختلاف.',

    'qibla.title': 'القبلة',
    'qibla.fromNorth': 'من الشمال',
    'qibla.aria': 'القبلة على {degrees} درجة من الشمال الحقيقي',
    'qibla.needsPermission': 'يحتاج هذا الجهاز إلى إذن قبل أن يعمل كبوصلة.',
    'qibla.usecompass': 'استخدام بوصلة الجهاز',
    'qibla.noCompass': 'لا تتوفر قراءة بوصلة هنا. اتجه إلى {degrees}° من الشمال الحقيقي باستخدام بوصلة.',

    'cards.title': 'اعرض هذا على العاملين',
    'cards.type': 'نوع البطاقة',
    'cards.language': 'اللغة',
    'cards.halal': 'حلال',
    'cards.vegetarian': 'نباتي',
    'cards.allergies': 'حساسية',
    'cards.hint': 'ارفع سطوع الشاشة وناوِل الهاتف.',

    'saved.title': 'المحفوظات',
    'saved.emptyTitle': 'لا شيء محفوظ بعد.',
    'saved.emptyBody': 'اضغط على علامة الحفظ في أي مكان ليبقى هنا — ويظل متاحاً دون اتصال.',
    'saved.emptyCta': 'ابحث عن مكان للأكل',
    'saved.staleOne': 'مكان محفوظ واحد يحمل شهادة لم تعد سارية.',
    'saved.staleOther': '{count} أماكن محفوظة تحمل شهادات لم تعد سارية.',
    'saved.staleBody': ' تنتهي الشهادات بعد الحفظ — تحقق قبل الذهاب.',
    'saved.remove': 'إزالة {name} من المحفوظات',

    'lang.choose': 'اختر لغة',
    'lang.label': 'اللغة',

    'time.today': 'اليوم',
    'time.yesterday': 'أمس',
    'time.daysAgo': 'قبل {count} أيام',
    'time.on': 'في {date}',
};
